<template>
  <div class="action-form">
    <div>
      <avatar
        v-if="!validateStringIsNull(userProfile.urlAvatar)"
        :src="userProfile.urlAvatar"
        backgroundColor="#e5e5e5"
        color="#0097A7"
        :size="90"
        style="margin: auto"
      ></avatar>
      <avatar
        v-else
        :username="userProfile.fullName"
        backgroundColor="#e5e5e5"
        color="#0097A7"
        :size="90"
        style="margin: auto"
      ></avatar>
      <div class="text-center pb-2 pt-2 text-nowrap" style="word-break: break-all">
        <p class="mb-2 primary-color font-weight-bold">{{ userProfile.fullName }}</p>
        <p class="mb-2 primary-color">{{ userProfile.email }}</p>
      </div>
    </div>
    <div class="divider-text bg-light pt-1 pb-1"></div>
    <div>
      <form>
        <div class="form-group primary-color text-nowrap">
          <p
            data-toggle="dropdown"
            @click="onViewProfile"
            class="mouse-pointer mb-2"
          >
            {{ $t("profile.title") }}
          </p>
          <p @click="onChangeLanguage" class="mouse-pointer mb-2">
            {{ $t("common.language") }}:
            {{
              $i18n.locale === "en"
                ? $t("common.english")
                : $t("common.vietnamese")
            }}
          </p>
          <p
            @click="onClickRegisterSupplier"
            data-toggle="dropdown"
            class="mouse-pointer mb-2"
          >
            {{ $t("common.registerToBecomeSupplier") }}
          </p>
        </div>
      </form>
    </div>
    <div class="divider-text bg-light pt-1 pb-1 mb-2"></div>
    <button
      type="submit"
      class="btn btn-primary btn-block"
      @click="onLogout($event)"
    >
      <span>{{ $t("common.logout") }}</span>
    </button>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { isCookieEnabled, getCookie } from "tiny-cookie";
import Avatar from "vue-avatar";
import functionUtils from "Utils/functionUtils";
export default {
  components: {
    avatar: Avatar,
  },
  data: () => ({
    userProfile: {
      id: null,
      username: null,
      fullName: "",
      email: null,
      gender: null,
      birtdate: null,
      phone: null,
      urlAvatar: null
    },
  }), 
  watch: {
    GET_CURRENT_ACCOUNT() {
      this.userProfile.id = this.GET_CURRENT_ACCOUNT.id;
      this.userProfile.username = this.GET_CURRENT_ACCOUNT.username;
      if (
        !functionUtils.isNull(this.GET_CURRENT_ACCOUNT.lastname) &&
        !functionUtils.isNull(this.GET_CURRENT_ACCOUNT.firstname)
      ) {
        this.userProfile.fullName =
          this.GET_CURRENT_ACCOUNT.lastname +
          " " +
          this.GET_CURRENT_ACCOUNT.firstname;
      }
      this.userProfile.email = this.GET_CURRENT_ACCOUNT.email;
      this.userProfile.urlAvatar = this.GET_CURRENT_ACCOUNT.url_avatar
    },
  },
  computed: {
    ...mapGetters(['GET_CURRENT_ACCOUNT'])
  },
  methods: {
    validateStringIsNull: function (value) {
      return functionUtils.validateStringIsNull(value)
    },
    onLogout: function(event) {
      event.preventDefault();
      let token = isCookieEnabled() ? getCookie("token") : null;
      this.LOGOUT(token)
        .then(
          function() {
            this.$emit('logOutSuccess')
            this.$router.push({
              name: 'LookUpVoucher'
            })
          }.bind(this)
        )
        .catch(
          function() {
            this.$emit('logOutSuccess')
            this.$router.push({
              name: 'LookUpVoucher'
            })
          }.bind(this)
        );
    },
    onClickRegisterSupplier: function(){
      let aminUlr = process.env.VUE_APP_ADMIN_URL;
      let url = aminUlr + "/register-supplier";
      let urlData = functionUtils.removeDoubleSlashesFromUrl(url);
      window.open(urlData, "_blank");
    },
    onChangeLanguage(){
      let locale = this.$i18n.locale === 'en' ? 'vi' : 'en'
      this.CHANGE_LOCALE(locale);
    },
    onViewProfile: function() {
      this.$router.push({
        name: "Profile",
      });
    },
    ...mapActions(['CHANGE_LOCALE', 'LOGOUT'])
  },
  created() {
    this.userProfile.id = this.GET_CURRENT_ACCOUNT.id;
    this.userProfile.username = this.GET_CURRENT_ACCOUNT.username;
    if (
      !functionUtils.isNull(this.GET_CURRENT_ACCOUNT.lastname) &&
      !functionUtils.isNull(this.GET_CURRENT_ACCOUNT.firstname)
    ) {
      this.userProfile.fullName =
        this.GET_CURRENT_ACCOUNT.lastname +
        " " +
        this.GET_CURRENT_ACCOUNT.firstname;
    }
    this.userProfile.email = this.GET_CURRENT_ACCOUNT.email;
    this.userProfile.urlAvatar = this.GET_CURRENT_ACCOUNT.url_avatar
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/color.scss";
.action-form {
  min-width: 250px;
  padding: 20px;
  left: auto;
  right: 0;
  font-size: 14px;
}
.action-form a {
  color: #33cabb;
  padding: 0 !important;
  font-size: 14px;
}
.action-form .hint-text {
  text-align: center;
  margin-bottom: 15px;
  font-size: 13px;
}
.btn-primary,
.btn-primary:active {
  color: #fff;
  background: #33cabb !important;
  border: none;
}
.btn-primary:hover,
.btn-primary:focus {
  color: #fff;
  background: #31bfb1 !important;
}
.divider-text:after {
  content: "";
  position: absolute;
  width: 100%;
  border-bottom: 1px solid #ddd;
  top: 55%;
  left: 0;
  z-index: 1;
}
.divider-text {
  position: relative;
  text-align: center;
  margin-bottom: 15px;
}
.mouse-pointer:hover{
  color: $second-500
}
</style>